<script setup>
const model = defineModel()

defineProps({
  name: String,
  error: String,
  required: Boolean
})

function update(val) {
  model.value = parseFloat(val)
}
</script>

<template>
<div class="input input--number">
  <p class="input__question">
    <slot name="question"></slot>
    <i class="fas fa-asterisk" v-if="required"></i>
  </p>

  <small class="text-muted input__description" v-if="$slots.description">
    <slot name="description"></slot>
  </small>

  <div class="form-group">
    <input
        type="number"
        min="0"
        :name="name"
        class="form-control"
        @input="update($event.target.value)"
        :required="required"
    />
  </div>
  <p class="form-error" v-if="error" v-text="error" role="alert" aria-live="assertive"></p>
</div>
</template>